module.exports = __webpack_public_path__ + "static/media/ravenclaw-2019.6a36b05a.png";